<div class="login-page vh-100 bg-secondary">
  <div class="container">
    <div class="row py-5">
      <div class="col-12 col-md-4 offset-md-4 text-center">
        <img class="d-block w-100" src="assets/images/logo.svg" alt="hello-one Enterprise">
      </div>

      <div class="col-12 col-md-6 offset-md-3 mt-5">
        <div class="card">
          <div class="card-body p-4">
            <div class="text-center">
              <h1 class="h4 text-uppercase">Registrieren</h1>
            </div>

            <form ngForm [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="row">
                <app-form-group
                  [formControl]="this.form.controls.invite_code"
                  type="text"
                  name="invite code"
                  label="Einladungscode"
                ></app-form-group>
              </div>

              <div class="row mt-2">
                <app-form-group
                  [formControl]="this.form.controls.email"
                  type="email"
                  name="email"
                  label="E-Mail Adresse (Benutzername)"
                ></app-form-group>
              </div>

              <div class="row mt-2">
                <app-form-group
                  [formControl]="this.form.controls.password"
                  type="password"
                  name="password"
                  label="Passwort"
                  autocomplete="current-password"
                  [errorMessages]="{required: 'Bitte geben Sie ein Passwort ein'}"
                ></app-form-group>
              </div>

              <div class="row mt-2">
                <app-form-group
                  [formControl]="this.form.controls.password_confirmation"
                  type="password"
                  name="confirm password"
                  label="Passwort bestätigen"
                  [errorMessages]="{required: 'Bitte geben Sie ein Passwort ein'}"
                ></app-form-group>
              </div>

              <div class="row my-3">
                <div class="col-12">
                  <button [disabled]="form.invalid" class="btn btn-primary w-100" type="submit">Registrieren</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
